<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="'pages.contacts.addBtns.addListNumber'"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
    [showRefreshBtn]="false"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <form [formGroup]="form" autocomplete="off">
      <div class="row">
        <div class="tw-w-full">
          <fieldset>
            <legend class="tw-flex-center">
              {{ fields + "phonebookGroup" | translate }}
            </legend>
            <!-- phonebookTitle -->
            <div class="sm:tw-w-1/2">
              <form-field
                [(value)]="phonebookTitle"
                [control]="form?.get('phonebook')"
                [label]="fields + 'phonebookGroup' | translate"
              >
              </form-field>
            </div>
          </fieldset>
        </div>
        <div class="tw-w-full tw-my-4">
          <fieldset>
            <legend class="tw-flex-center">
              {{ "common.numberList" | translate }}
            </legend>
            <mobile-numbers-widget
              [title]="'common.numberList' | translate"
              uniqId="contacts-number-list"
              [correctRows]="6"
              [wrongRows]="6"
              responsiveClass="tw-w-full"
              [form]="form"
              groupName="contactsNumberList"
              controlName="numbers"
              (mobileNumbers)="model = $event"
            >
            </mobile-numbers-widget>
          </fieldset>
        </div>
        <div class="tw-w-full">
          <section *ngIf="!formPageConfig.isEditMode">
            <app-delete-contact-by-cellphone
              [form]="form"
              (phonebookIdsModel)="deletePhonebookIdsModel = $event"
            >
            </app-delete-contact-by-cellphone>
          </section>
        </div>
      </div>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="false"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
